import React, {useState} from 'react';
import ModalWrapper from '../ModalWrapper';
import ModalUsadosBody from './ModalUsadosBody';

const ModalUsados = ({isOpen, onCloseModal}) => {
    return (
        <ModalWrapper isOpen={isOpen} cssClass="modal-usados-detail">
            <ModalUsadosBody onCloseModal={onCloseModal}/>
        </ModalWrapper>
    )
}

export default ModalUsados;